module.exports = __webpack_public_path__ + "resources/img/img_security_dfinder_fds2.8bffd63b31ae61f6ad077ec5c120586a.png";